module.exports = __webpack_public_path__ + "img/8.d7c1db4d.jpg";